import { Injectable } from '@angular/core';
import {from, Observable, of, throwError} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {classToPlain, plainToClass} from 'class-transformer';
import {db} from "../../dexie/db";

import { SOPutNotification } from './so-put-notification';
import { SOGetNotification } from './so-get-notification';
import { SOPostNotification } from './so-post-notification';
import { SODeleteNotification } from './so-delete-notification';
import {SORespNotification} from './so-resp-notification';
import {SOPluralNotification} from './so-plural-notification';

import {MMEntityService} from 'lionheartland';
import {EntityCoreProtocol} from 'lionheartland';
import {MMEntityServiceBase} from 'lionheartland';
import {HttpHeaders} from "@angular/common/http";

export class EONotificationService extends MMEntityServiceBase implements MMEntityService {

  constructor(
    public entityCore: EntityCoreProtocol,
  ) {
    super('notification', entityCore);
  }

  /** GET Notification by id. Will 404 if id not found */
  get(request: SOGetNotification): Observable<SOPluralNotification> {
    return this.httpClient.get<SOPluralNotification>(this.makeGetUri(request), this.httpOptions).pipe(
      map(resp => plainToClass(SOPluralNotification, resp)),
      tap(async (response: SOPluralNotification) => {
        this.log(`fetched Notification`);
        // After a successful server response, update IndexedDB
        const activities = response.toNotifications(); // Convert your response to an array of Notification instances
        const promises = activities.map(notification => db.notifications.put(notification));
        await Promise.all(promises); // Wait for all the IndexedDB update operations to complete
      }),
      catchError(this.handleError<SOPluralNotification>(`get Notification`))
    );
  }

    /** GETCACHE for initial display with CacheQueryProtocol */
    getCache(cacheQuery: any): Observable<SOPluralNotification> {
        console.log("GETCACHE", cacheQuery);

        if (cacheQuery.filterKey === 'notification' && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on parent and organization")
            return from(db.notifications.where('parentUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(notificationsArray => this.processNotifications(notificationsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }
        else if (cacheQuery.filterKey + "s" == "datafeed" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.notifications.where('datafeedUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(notificationsArray => this.processNotifications(notificationsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterKey + "s" == "message" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.notifications.where('messageUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(notificationsArray => this.processNotifications(notificationsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterKey + "s" == "organization" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.notifications.where('organizationUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(notificationsArray => this.processNotifications(notificationsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterOrganization || cacheQuery.organization.uid)
        {
            console.log("tripped organization for cache query")
            if ( cacheQuery?.filterOrganization != null )
            {
                console.log("cache filtering based on organization CQP", cacheQuery)
                return from(db.notifications.where('organizationUid').equals(cacheQuery.filterOrganization).toArray()).pipe(
                    map(notificationsArray => this.processNotifications(notificationsArray)),
                    catchError(error => this.handleQueryError(error))
                );
            }
            else if ( cacheQuery?.organization?.uid != null )
            {
                console.log("UID:", cacheQuery.organization.uid)
                console.log("cache filtering based on organization SOGet")
                return from(db.notifications.where('organizationUid').equals(cacheQuery.organization.uid).toArray()).pipe(
                    map(notificationsArray => this.processNotifications(notificationsArray)),
                    catchError(error => this.handleQueryError(error))
                );
            }
            else
            {
                console.log("null organization")
            }
        }
        else
        {
            console.log("cache no filter")
            return from(db.notifications.toArray()).pipe(
                map((notificationsArray) => {
                    // Convert the array of plain objects to an array of SORespNotification instances
                    const sorNotifications = notificationsArray.map(req => plainToClass(SORespNotification, req));
                    // Create and return a new instance of SOPluralNotification
                    const pluralNotification = new SOPluralNotification();
                    pluralNotification.objects = sorNotifications;
                    pluralNotification.nextOffset = null; // Assuming there is no pagination in cache
                    return pluralNotification;
                }),
                catchError(error => this.handleQueryError(error))
            );
        }
    }

    private processNotifications(notificationsArray) {
        const sorNotifications = notificationsArray.map(req => plainToClass(SORespNotification, req));
        const pluralNotification = new SOPluralNotification();
        pluralNotification.objects = sorNotifications;
        pluralNotification.nextOffset = null;
        return pluralNotification;
    }

    private handleQueryError(error) {
        console.error('Error in query:', error);
        return throwError(error); // Return an observable error
    }

post(request: SOPostNotification): Observable<SORespNotification> {
  return this.httpClient.post<SORespNotification>(this.coreUrl + this.route, request, this.httpOptions).pipe(
    map(resp => plainToClass(SORespNotification, resp)),

    tap(async (response: SORespNotification) => {
      this.log(`added Notification w/ id=${response.uid}`);
      // After a successful server response, update IndexedDB
      console.log("here", response);
      console.log("here request", request);
      await db.notifications.add(response.toNotification());
    }),
    catchError(this.handleError<SORespNotification>('Notification post'))
  );
}


  put(request: SOPutNotification): Observable<SORespNotification> {
    const uid = request.uid;
    const uri = `${this.coreUrl}${this.route}/${uid}`;
    return this.httpClient.put<SORespNotification>(uri, request, this.httpOptions).pipe(
      map(resp => plainToClass(SORespNotification, resp)),
      tap(async (response: SORespNotification) => {
        this.log(`edited Notification w/ uid=${uid}`);
        // After a successful server response, update IndexedDB
        await db.notifications.put(response.toNotification());
      }),
      catchError(this.handleError<SORespNotification>('Notification put'))
    );
  }


  delete(request: SODeleteNotification): Observable<SORespNotification> {
    return this.httpClient.delete<SORespNotification>(this.makeDeleteUri(request), this.httpOptions).pipe(
      tap(async _ => {
        this.log(`deleted Notification uid=${request.uid}`);
        // After a successful server response, update IndexedDB
        await db.notifications.delete(request.uid);
      }),
      catchError(this.handleError<SORespNotification>('Notification delete'))
    );
  }


}
